import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const HEADER_HEIGHT = {
  desktop: 80,
  tablet: 76,
  mobile: 76,
};

export function useHeaderHeight(): number {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));

  if (isSm) {
    return HEADER_HEIGHT.mobile;
  }

  if (isMd) {
    return HEADER_HEIGHT.tablet;
  }

  return HEADER_HEIGHT.desktop;
}
